import { render, staticRenderFns } from "./NavItemTree.vue?vue&type=template&id=36663435&scoped=true&name=nav-item-tree&"
import script from "./NavItemTree.vue?vue&type=script&lang=js&"
export * from "./NavItemTree.vue?vue&type=script&lang=js&"
import style0 from "./NavItemTree.vue?vue&type=style&index=0&id=36663435&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36663435",
  null
  
)

export default component.exports